import { render, staticRenderFns } from "./PartOfLocation.vue?vue&type=template&id=4c5dd3c9&"
import script from "./PartOfLocation.vue?vue&type=script&lang=js&"
export * from "./PartOfLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports